import { Address, badFallingBostelAddress, CompoundReference, dorfmarkAddress } from "./Domain";

export const isDorfmarkAddress = (address: Address) =>
	address.street === dorfmarkAddress.street
	&& address.zipCode === dorfmarkAddress.zipCode
	&& address.city === dorfmarkAddress.city;

export const isBadFallingBostelAddress = (address: Address) =>
	address.street === badFallingBostelAddress.street
	&& address.zipCode == badFallingBostelAddress.zipCode
	&& address.city == badFallingBostelAddress.city;

// Dorfmark Siemsglüss uses a distinct street address, so it isn't caught by isDorfmarkAddress -
// compound name comparison is required to reliably detect all Dorfmark sub-compounds.
export const dorfmarkCompoundNames = ["Dorfmark", "Dorfmark Bahnhof", "Dorfmark Siemsglüss"];

export const isDorfmarkCompound = (compound?: CompoundReference | null) =>
	!!compound && dorfmarkCompoundNames.includes(compound.name);
